import React, { useState, useEffect, useContext } from 'react';
import {Route, Routes} from "react-router-dom";
import {withRouter} from "../lib/react/withRouter";
import {observer} from "mobx-react";

import Bo_Home from './bo/home.js';
import Bo_Vgrps from './bo/vgrps.js';
import Bo_Pays from './bo/pays.js';
import Bo_Tax from './bo/tax.js';
import Bo_Cas from './bo/cas.js';
import sso from "../sso";


class Tmpl_Bo extends React.Component {
    //var sdo = useContext(SDO);
    constructor(props, context) {
        super(props);

        this.store = props.store;
        this.state = {};
        //context.posrend = this;

        var po = {};
        po.reg = { "fid": "f06", "url": "/tmpl/bo/vgrps", "name": "Varugrupper", "active": false };
        po.pays = { "fid": "f06", "url": "/tmpl/bo/pays", "name": "Betalmedel", "active": false };
        po.tax = { "fid": "f06", "url": "/tmpl/bo/tax", "name": "Momskoder", "active": false };
        po.cas = { "fid": "f06", "url": "/tmpl/bo/cas", "name": "Kassörer", "active": false };
        //po.tech = { "fid": "f06", "url": "/tmpl/tech", "name": "Teknik", "active": false };
        this.state.po = po;
        this.state.pa = [];
        this.state.pa = Object.values(po);
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
    }
    componentDidMount() {
        /*
        var path = window.location.pathname;
        if(path.substr(-1) == "/") path = path.substring(0, path.length - 1);
        var op = path.split("/").pop();

        var po = this.state.po;
        if(po[op]) {
            po[op].active = true;
            //this.props.store.fkn = po[op];
            sbo.state.fkn = po[op].name;
            //alert(JSON.stringify(sbo.state));
        }
        var pa = Object.values(po);
        this.setState({ po: po, pa: pa });
         */
    }
    fknGo(row) {
        sso.seo.sfkn = row;
        this.props.navigate(row.url);
    }
    br_css(row) {
        var css = {};
        if(sso.seo.sfkn && (row.url == sso.seo.sfkn.url)) css.color = "#080";
        //var brc = false;
        //if(row.url == sbo.state.url) brc = true;
        return css;
    }

    render() {
        return (
            <div className="web-app">
                { this.props.store.cfg.bread ?
                    <div className="web-bread">
                        <div className="breadcrumb">
                            { this.state.pa.map((row, key) =>
                                <div key={key} className="breadcrumb-item" style={this.br_css(row)} onClick={() => this.fknGo(row)}>{row.name}</div>
                            )}
                            <div className="flex"></div>
                            <div className="cdigreen">{ sso.sdo.sfkn ? sso.sdo.sfkn.name : null }</div>
                        </div>
                    </div>
                    : null }
        <Routes>
            <Route path="vgrps" element={ <Bo_Vgrps store={this.store} />} />
            <Route path="pays" element={ <Bo_Pays store={this.store} />} />
            <Route path="tax" element={ <Bo_Tax store={this.store} />} />
            <Route path="cas" element={ <Bo_Cas store={this.store} />} />
            <Route path="di" element={ <Bo_Home store={this.store} />} />
            <Route path="*" element={ <Bo_Home store={this.store} />} />
        </Routes>
    </div>
  );
}
}
//Sys.contextType = ADOContext;

export default withRouter(observer(Tmpl_Bo));
